module.exports = __webpack_public_path__ + "img/Master.93c9fc06.png";